
import Twitter from "../../../assets/outline/Twitter.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TwitterIcon({ className, dataTestid = "TwitterIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Twitter data-testid={dataTestid} className={classes} {...rest} />
  );
}
